module.exports = __webpack_public_path__ + "./assets/wahoo-1bfe66.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wahoo.bmp
// module id = 21
// module chunks = 0